import React, { Component } from 'react'

import { connect } from 'react-redux'
import { extractFilterOptions, updateFilterOptions, updateObject } from '../../../helpers/utils'
import * as actions from '../../../store/actions'

import Aux from '../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../components/Alert/Alert'
import EmployeeContent from '../../../components/PageContent/Employee/EmployeeContent/EmployeeContent'
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../components/FilterModal/FilterModal'
import ImportModal from '../../../components/PageContent/AppraisalItem/ImportModal/ImportModal'
import { withTranslate } from 'react-redux-multilingual'

// Adding/Editing in this page will not render an edit modal.
// Instead, we will render an add/edit page

class Employee extends Component {
  state = {
    filterModalOpen: false,
    confirmationModalOpen: false,
    importModalOpen: false,
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        }
        // loading: true
      },
      level_id: {
        label: this.props.translate('employeeLevel'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('employeeLevel'),
          options: []
        }
        // loading: true
      },
      org_id: {
        label: this.props.translate('organization'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('organization'),
          options: []
        }
        // loading: true
      },
      position_id: {
        label: this.props.translate('position'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('position'),
          options: []
        }
        // loading: true
      },
      emp_id: {
        label: this.props.translate('employeeName'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('employee'),
          options: []
        }
        // loading: true
      }
    },
    selectedEmps: [],
    importFile: [],
    companyOptions: [],
    empLevelOptions: [],
    orgOptions: [],
    positionOptions: [],
    empOptions: [],
    filterText: ''
  }

  componentDidMount = () => {
    this.props.fetchEmployees()
    this.props.fetchCompanyOptions()
  }
  static getDerivedStateFromProps(props, state) {
    if (state.companyOptions !== props.companyOptions) {
      const companyFilter = { ...state.filterControls.company_id, loading: false }
      const updatedCompanyFilter = updateFilterOptions(
        props.companyOptions,
        companyFilter,
        'company_id',
        'company_id',
        { code: 'company_code', name: 'company_name' },
        true,
        null
      )
      const updatedFilterControls = updateObject(state.filterControls, {
        company_id: updatedCompanyFilter
      })
      return {
        filterControls: updatedFilterControls,
        companyOptions: props.companyOptions
      }
    }
    if (state.empLevelOptions !== props.empLevelOptions) {
      const empLevelFilter = { ...state.filterControls.level_id, loading: false }
      const updatedEmpLevelFilter = updateFilterOptions(
        props.empLevelOptions,
        empLevelFilter,
        'level_id',
        'level_id',
        'level_name',
        true,
        null
      )
      const updatedFilterControls = updateObject(state.filterControls, {
        level_id: updatedEmpLevelFilter
      })
      return {
        filterControls: updatedFilterControls,
        empLevelOptions: props.empLevelOptions
      }
    }
    if (state.orgOptions !== props.orgOptions) {
      const orgFilter = { ...state.filterControls.org_id, loading: false }
      const updatedOrgFilter = updateFilterOptions(
        props.orgOptions,
        orgFilter,
        'org_id',
        'org_id',
        'org_name',
        true,
        null
      )
      const updatedFilterControls = updateObject(state.filterControls, {
        org_id: updatedOrgFilter
      })
      return {
        filterControls: updatedFilterControls,
        orgOptions: props.orgOptions
      }
    }
    if (state.positionOptions !== props.positionOptions) {
      const positionFilter = { ...state.filterControls.position_id, loading: false }
      const updatedPositionFilter = updateFilterOptions(
        props.positionOptions,
        positionFilter,
        'position_id',
        'position_id',
        'position_name',
        true,
        null
      )
      const updatedFilterControls = updateObject(state.filterControls, {
        position_id: updatedPositionFilter
      })
      return {
        filterControls: updatedFilterControls,
        positionOptions: props.positionOptions
      }
    }
    if (state.empOptions !== props.empOptions) {
      const empFilter = { ...state.filterControls.emp_id, loading: false }
      const updatedEmpFilter = updateFilterOptions(
        props.empOptions,
        empFilter,
        'emp_id',
        'emp_id',
        'full_name',
        true,
        null
      )
      const updatedFilterControls = updateObject(state.filterControls, {
        emp_id: updatedEmpFilter
      })
      return {
        filterControls: updatedFilterControls,
        empOptions: props.empOptions
      }
    }
    return null
  }

  // records actions
  empSelectedHandler = recordId => {
    let selectedEmps = [...this.state.selectedEmps]

    if (selectedEmps.includes(recordId)) {
      selectedEmps = selectedEmps.filter(selectedId => selectedId !== recordId)
    } else {
      selectedEmps.push(recordId)
    }

    this.setState({
      selectedEmps
    })
  }

  pageChangeHandler = (e, page) => {
    const pageOptions = {
      perPage: this.props.pagination.perPage,
      page: page
    }
    const filters = extractFilterOptions(this.state.filterControls, pageOptions)

    this.props.fetchEmployees(filters)
  }

  perPageChangeHandler = perPage => {
    const pageOptions = {
      perPage: perPage,
      page: this.props.pagination.currentPage
    }
    const filters = extractFilterOptions(this.state.filterControls, pageOptions)

    this.props.fetchEmployees(filters)
  }

  // Delete Confirmation Functions
  openConfirmationHandler = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false,
      selectedEmps: []
    })
  }

  deleteRecords = () => {
    this.props.deleteEmps(this.state.selectedEmps)
    this.closeConfirmationModal()
  }

  // Filter Functions
  openFilterModal = () => {
    this.setState({
      filterModalOpen: true
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false,
      selectedEmps: []
    })
  }

  filterChangedHandler = (itemKey, event) => {
    let value = event

    const filterControls = { ...this.state.filterControls }
    const updatedItem = { ...filterControls[itemKey], value }
    let updatedFilterControls = updateObject(filterControls, { [itemKey]: updatedItem })

    let companyId = null
    let levelId = null
    let positionId = null
    let orgId = null

    switch (itemKey) {
      case 'company_id':
        this.props.fetchEmpLevelOptions({ company_id: value?.value })
        this.props.fetchPositionOptions({ company_id: value?.value })
        this.props.fetchOrgOptions({ company_id: value?.value })
        this.props.fetchEmpOptions({ company_id: value?.value })
        updatedFilterControls = Object.entries(updatedFilterControls)
          .filter(item => item[0] !== itemKey)
          .reduce(
            (updatedFilterControls, filterItem) => {
              let [filterKey, filterAttr] = filterItem
              const updatedFilterAttr = { ...filterAttr, value: '', loading: true }
              return updateObject(updatedFilterControls, { [filterKey]: updatedFilterAttr })
            },
            { company_id: updatedItem }
          )
        break
      case 'level_id':
        companyId = filterControls.company_id.value?.value || null
        positionId = filterControls.position_id.value?.value || null
        this.props.fetchOrgOptions({ company_id: companyId, level_id: value?.value })
        this.props.fetchEmpOptions({
          company_id: companyId,
          position_id: positionId,
          level_id: value?.value
        })
        updatedFilterControls = updateObject(updatedFilterControls, {
          org_id: { ...filterControls.org_id, value: '', loading: true },
          emp_id: { ...filterControls.emp_id, value: '', loading: true }
        })
        break
      case 'org_id':
        companyId = filterControls.company_id.value?.value || null
        levelId = filterControls.level_id.value?.value || null
        positionId = filterControls.position_id.value?.value || null
        this.props.fetchEmpOptions({
          company_id: companyId,
          level_id: levelId,
          position_id: positionId,
          org_id: value?.value
        })
        updatedFilterControls = updateObject(updatedFilterControls, {
          emp_id: { ...filterControls.emp_id, value: '', loading: true }
        })

        break
      case 'position_id':
        companyId = filterControls.company_id.value?.value || null
        levelId = filterControls.level_id.value?.value || null
        orgId = filterControls.org_id.value?.value || null
        this.props.fetchEmpOptions({
          company_id: companyId,
          level_id: levelId,
          org_id: orgId,
          position_id: value?.value
        })
        updatedFilterControls = updateObject(updatedFilterControls, {
          emp_id: { ...filterControls.emp_id, value: '', loading: true }
        })
        break
      default:
        break
    }

    this.setState({
      filterControls: updatedFilterControls
    })
  }

  filterRecords = () => {
    const filters = extractFilterOptions(this.state.filterControls, {
      page: 1,
      perPage: this.props.pagination.perPage
    })

    this.closeFilterModal()

    this.props.fetchEmployees(filters)
  }

  // Import Functions
  openImportModal = () => {
    this.setState({
      importModalOpen: true
    })
  }

  closeImportModal = () => {
    this.setState({
      importModalOpen: false,
      importFile: null
    })
  }

  importFileChangedHandler = event => {
    const file = event.target.files[0]
    this.setState({
      importFile: file
    })
  }

  importHandler = () => {
    this.props.importEmps(this.state.importFile)
    this.closeImportModal()
  }

  // Export functions
  exportHandler = () => {
    const filterOptions = extractFilterOptions(this.state.filterControls)
    this.props.exportEmps(filterOptions)
  }

  // Download Functions
  downloadHandler = () => {
    const filterOptions = extractFilterOptions(this.state.filterControls)
    this.props.downloadTemplate(filterOptions)
  }

  filterTextChangeHandler = e => {
    this.setState({
      filterText: e.target.value
    })
  }

  render() {
    if (this.props.downloading) {
      document.body.style.cursor = 'wait'
    } else {
      document.body.style.cursor = null
    }

    let importDisabled = true
    const pagePermission = this.props.pagePermission

    if (pagePermission.is_add && pagePermission.is_edit) {
      importDisabled = false
    }

    let filteredRecords = this.props.records.filter(records => {
      return (
        records.emp_code?.includes(this.state.filterText) ||
        records.full_name?.includes(this.state.filterText)
      )
    })

    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecords}
          promptText={this.props.translate('confirmDel')}
        />
        <Alert />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.filterChangedHandler(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <ImportModal
          open={this.state.importModalOpen}
          cancelled={this.closeImportModal}
          fileChanged={this.importFileChangedHandler}
          fileSubmit={this.importHandler}
          selectedFile={this.state.importFile}
        />
        <EmployeeContent
          // Actions Props
          exporting={this.exportHandler}
          importing={this.openImportModal}
          downloading={this.downloadHandler}
          filtering={this.openFilterModal}
          importDisabled={importDisabled}
          // Header Props
          addDisabled={!pagePermission.is_add}
          deleting={this.openConfirmationHandler}
          deleteDisabled={!pagePermission.is_delete}
          // Emp Data Props
          employeeData={filteredRecords}
          loading={this.props.loading}
          empSelected={this.empSelectedHandler}
          selectedEmps={this.state.selectedEmps}
          editDisabled={!pagePermission.is_edit}
          // Pagination Props
          pagination={this.props.pagination}
          perPageChanged={this.perPageChangeHandler}
          pageChange={this.pageChangeHandler}
          // Filter Props
          filterText={this.state.filterText}
          filterTextChanged={this.filterTextChangeHandler}
        />
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.employees.pagination,
    records: state.employees.records,
    loading: state.employees.recordsLoading,
    downloading: state.employees.downloading,
    filterModalLoading: state.employees.filterLoadingStates.length,
    companyOptions: state.employees.companies,
    empLevelOptions: state.employees.empLevels,
    orgOptions: state.employees.orgs,
    positionOptions: state.employees.positions,
    empOptions: state.employees.emps
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchEmployees: filterOptions => {
      dispatch(actions.fetchEmployees(filterOptions))
    },
    fetchCompanyOptions: () => {
      dispatch(actions.fetchCompanyOptions())
    },
    fetchEmpLevelOptions: filters => {
      dispatch(actions.fetchEmpLevelOptions(filters))
    },
    fetchOrgOptions: filters => {
      dispatch(actions.fetchOrganizationOptionsForEmployee(filters))
    },
    fetchPositionOptions: filters => {
      dispatch(actions.fetchPositionOptions(filters))
    },
    fetchEmpOptions: filters => {
      dispatch(actions.fetchEmployeeOptions(filters))
    },
    importEmps: importFile => {
      dispatch(actions.importEmployee(importFile))
    },
    exportEmps: filterOptions => {
      dispatch(actions.exportEmployee(filterOptions))
    },
    downloadTemplate: filterOptions => {
      dispatch(actions.downloadEmployeeTemplate(filterOptions))
    },
    deleteEmps: selectedEmps => {
      dispatch(actions.deleteEmployees(selectedEmps))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(Employee))
